import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Accueil from "./pages/Accueil";
import About from "./pages/About";
import Categories from "./pages/Categories";
import MovieDetails from "./pages/MovieDetails";
import ActorDetails from "./pages/ActorDetails";
import Search from "./pages/Search";

const App = () => {
  return(
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Accueil} />
        <Route path="/about" exact component={About} />
        <Route path="/categories" exact component={Categories} />
        <Route path="/movieDetails" exact component={MovieDetails} />
        <Route path="/actorDetails" exact component={ActorDetails} />
        <Route path="/search" exact component={Search} />
      </Switch>
    </BrowserRouter>
  )
}

export default App;